/** Official Nikao brand palette (brand guidelines). */
export const NIKAO_BRAND = {
  aubergine: "#160E2B",
  magenta: "#A02B93",
  lime: "#A2BC1F",
  /** Darkened lime for white-on-colour UI (e.g. tile headers). */
  limeDark: "#6E8515",
  indigo: "#422A80",
  ocean: "#0F9ED5",
  teal: "#00BF8F",
  white: "#FFFFFF",
};

/**
 * Dashboard tile header colours (body stays white; header text always white).
 * Lime is darkened so white title text stays readable.
 */
export const DASHBOARD_TILE_STYLES = {
  businessServices: {
    headerColor: NIKAO_BRAND.aubergine,
  },
  certsSecrets: {
    headerColor: NIKAO_BRAND.ocean,
  },
  assetRegister: {
    headerColor: NIKAO_BRAND.teal,
  },
  softwarePermissions: {
    headerColor: NIKAO_BRAND.indigo,
  },
  clients: {
    headerColor: NIKAO_BRAND.limeDark,
  },
  aiSystems: {
    headerColor: NIKAO_BRAND.magenta,
  },
};
